var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification"},[_c('div',{staticClass:"form"},[(_vm.isSuccess)?_c('span',[_vm._v(_vm._s(_vm.formText.success)+".")]):_vm._e(),(!_vm.isSuccess)?_c('span',[_vm._v(_vm._s(_vm.formText.error)+".")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }